!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.target = null, this.originalContent = null, this.placeholder = null, 
      this.details = this.querySelector("details"), this.summary = this.querySelector("summary"), 
      this.disableBodyScroll = this.hasAttribute("data-scroll-lock");
    }
    connectedCallback() {
      this.details && this.summary ? (this.updateTarget(), this.setupCloseElements(), 
      this.details.addEventListener("toggle", this.handleToggle.bind(this))) : console.warn("<teleport-details> must contain both <details> and <summary> elements.");
    }
    updateTarget() {
      const t = this.getAttribute("to");
      t ? (this.target = document.querySelector(t), this.target || console.warn(`Teleport target '${t}' not found.`)) : console.warn("<teleport-details> is missing a `to` attribute for teleport target.");
    }
    setupCloseElements() {
      this.details.querySelectorAll("[data-close]").forEach((t => {
        t.addEventListener("click", (() => {
          this.details.open = !1, this.restoreContent();
        }));
      }));
    }
    handleToggle() {
      this.details.open ? (this.teleportContent(), this.disableBodyScroll && document.body.classList.add("overflow-hidden")) : (this.restoreContent(), 
      this.disableBodyScroll && document.body.classList.remove("overflow-hidden"));
    }
    teleportContent() {
      this.target && (this.originalContent || (this.originalContent = Array.from(this.details.childNodes).filter((t => !(1 === t.nodeType && "SUMMARY" === t.tagName)))), 
      this.placeholder || (this.placeholder = document.createElement("div"), this.placeholder.style.display = "none", 
      this.details.appendChild(this.placeholder)), this.originalContent.forEach((t => {
        this.target.appendChild(t);
      })));
    }
    restoreContent() {
      this.originalContent && this.placeholder && (this.originalContent.forEach((t => {
        this.details.insertBefore(t, this.placeholder);
      })), this.placeholder.remove(), this.placeholder = null, this.originalContent = null);
    }
  }
  customElements.get("teleport-details") || customElements.define("teleport-details", t);
}();